

import {computed, onMounted, ref} from 'vue'
import {useToast} from "primevue/usetoast";
import {FilterMatchMode} from "primevue/api";
import moment from "moment";
import theoDoiRepository from "@/services/TheoDoiRepository";
import {TinhTien} from "@/models/tinhTien";
import {DieuTri} from "@/models/dieuTri";
import {values} from "lodash";
import {Dashboard} from "@/models/dashboard";
import takeColor from "@/utils/color";
import {DoanhThu} from "@/models/doanhThu";


export default {
  setup: function () {
    const toast = useToast();
    const date = ref();
    const doanhThu = ref([] as TinhTien[]);
    const listDieuTri = ref([] as DieuTri[]);
    const tongTien = ref(0);
    const noiTru = ref(0);
    const xuatVien = ref(0);
    const vaoVien = ref(0);
    const khamBenh = ref(0);
    const checkSelect = ref(false);
    const dashboard = ref({} as Dashboard);
    const listColor = ref([] as string[]);

    listColor.value = takeColor(30);
    theoDoiRepository.dashboard()
        .then((response) => {
          dashboard.value = response.data;
        })
        .catch(err => {
          toast.add({
            severity: 'error',
            summary: 'Lỗi',
            detail: err.response.data,
            life: 2000
          });
        })
    const doanhThuCaNam = ref([] as DoanhThu[]);
    const loadingBar = ref(true);
    theoDoiRepository.dsdoanhthu()
        .then((response) => {
          doanhThuCaNam.value = response.data;
          loadingBar.value = false;
        })
        .catch(err => {
          toast.add({
            severity: 'error',
            summary: 'Lỗi',
            detail: err.response.data,
            life: 2000
          });
        });

    const totalData = computed(() => {
      //console.log("################ loadData totalData: ");
      const data = dashboard.value;
      //console.log("################ loadData data: " + data);
      console.log("################ loadData data: " + JSON.stringify(data));
      return {
        labels: ['Số khám bệnh', 'Bệnh nhân cũ', 'Bệnh nhân mới', 'Bệnh nhân ra viện', 'Bệnh nhân chuyển viện', 'Siêu âm', 'Xquang', 'Xét nghiệm', 'Khám sức khoẻ'],
        datasets: [
          {
            label: '',
            data: [data.slKham, data.bN_Cu, data.bN_Moi, data.bN_RaVien, data.bN_ChuyenVien, data.sieuAm, data.xquang, data.xetNghiem, data.khamSucKhoe],
            backgroundColor: listColor.value,
          }
        ]
      }
    });

    const basicOptions = ref(
        {
          plugins: {
            legend: {
              labels: {
                color: '#495057'
              }
            }
          },
          scales: {
            x: {
              ticks: {
                color: '#495057'
              },
              grid: {
                color: '#ebedef'
              }
            },
            y: {
              ticks: {
                color: '#495057'
              },
              grid: {
                color: '#ebedef'
              }
            }
          }
        }
    );

    const selectCalendar = () => {
      if((date.value[0] != null)&&(date.value[1] != null)) {
        checkSelect.value = true;
        theoDoiRepository.dashboardInTime(date.value[0]/1000, date.value[1]/1000)
            .then((response) => {
              dashboard.value = response.data;
            })
            .catch(err => {
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail: err.response.data,
                life: 2000
              });
            })
    }};

    const clearCalendar = () => {
        checkSelect.value = false;
        // loadData();
    }

    const totalDataYear = computed(() => {
      //console.log("################ loadData totalData: ");
      const data = doanhThuCaNam.value;
      //console.log("################ loadData data: " + data);
      return {
        labels: data.map(x => x.thang),
        datasets: [
          {
            label: 'Doanh thu năm trước',
            data: data.map(x => x.namTruoc),
            backgroundColor: '#ffdc82',
          },
          {
            label: 'Doanh thu năm nay',
            data: data.map(x => x.namNay),
            backgroundColor: '#82c4ff',
          }
        ]
      }
    });

    const options = computed(() => {
      const data = dashboard.value;
     return{
       plotOptions: {
         bar: {
           distributed: true,
           columnWidth: '75%',
           endingShape: 'flat',
           dataLabels: {
             position: "top"
           },
         }
       },
       dataLabels: {
         offsetY: -20,
         style: {
           fontSize: '16px',
           colors: ["#304758"]
         }
       },
       chart: {
         id: 'Thống_kê_bệnh_nhân'
       },
       xaxis: {
         categories: ['Số khám bệnh', 'Bệnh nhân cũ', 'Bệnh nhân mới', 'Bệnh nhân ra viện', 'Bệnh nhân chuyển viện', 'Siêu âm', 'Xquang', 'Xét nghiệm', 'Khám sức khoẻ']
       }
     }
    })

    const series = computed(() => {
      const data = dashboard.value;
      return [{
        name: 'Số bệnh nhân: ',
        data: [data.slKham, data.bN_Cu, data.bN_Moi, data.bN_RaVien, data.bN_ChuyenVien, data.sieuAm, data.xquang, data.xetNghiem, data.khamSucKhoe]
      }]
    })

    return {
      totalData,
      doanhThu,
      tongTien,
      noiTru,
      vaoVien,
      xuatVien,
      selectCalendar,
      date,
      khamBenh,
      clearCalendar,
      basicOptions,
      totalDataYear,
      loadingBar,
      dashboard,
      options,
      series,
    }
  }

}
